var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-5",attrs:{"flat":""}},[_c('Header'),_c('Table')],1),_c('Form'),(_vm.showNotice)?_c('Notice',{staticClass:"my-5"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }